<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧社区</h2>
        <h3>建行无人值守无感支付停车管理系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <div>
          <h2>建行无人值守无感支付停车管理系统</h2>
          <p>
            车牌识别停车收费管理系统现在非常稳定也普及了。 随着社会科技发 展，人们对停车 体验又提出新要求，例如现行车牌识别系统还停留在 非常原始的有人收费管理的基础上， 这样就不仅给物业公司带来特别 大的人力成本也增加管理成本，更重要的是人工收费找零 太慢，严重 影响了车辆通行速度，给车主停车的体验感很差，这样就整体降低了 停车场档 次。
            现在我司研发出无人值守车牌识别收费系统，既可大 大降低物业人力和管理成本，也 可以很好改善车主停车体验感，从 而可以使停车物业管理提升好几个档次。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScemotionlessParking',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
</style>
